import CartEpics from './cart'
import CollectionEpics from './collection'
import FavoriteEpics from './favorite'
import FollowEpics from './follow'
import SessionEpics from './session'
export default [...CartEpics, ...CollectionEpics, ...FavoriteEpics, ...FollowEpics, ...SessionEpics]